import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const Svg360 = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17 10.5699V8.27316C18.8412 9.18869 20 10.5192 20 12C20 14.7614 15.9706 17 11 17C6.02944 17 2 14.7614 2 12C2 10.5192 3.15875 9.18869 5 8.27316V10.5699C4.36077 11.0297 4 11.5341 4 12C4 13.3405 6.98711 15 11 15C15.0129 15 18 13.3405 18 12C18 11.5341 17.6392 11.0297 17 10.5699ZM9 7V11H13V7H9ZM7 5H15V13H7V5Z"
      fill="currentColor"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(Svg360);

export default ForwardRef;
